<template>
  <div class="entity-card" @click="() => onClick()">
    <ImagesHeader small :cover-url="coverUrl" :logo-url="logoUrl" />
    <div class="content">
      <h2 class="name">{{ props.name }}</h2>
      <p v-if="numLocations" class="locations">
        {{ props.numLocations }} location{{ props.numLocations === 1 ? '' : 's' }}
      </p>
      <!-- <p class="tags">{{ props.tags?.join(', ') }}</p> -->
    </div>
  </div>
</template>

<script setup>
import ImagesHeader from '@/pages/talent-pool/location-settings/components/ImagesHeader.vue';
import { useRouter } from 'vue-router/composables';

const router = useRouter();

const props = defineProps(['name', 'numLocations', 'tags', 'entityId', 'entityType', 'coverUrl', 'logoUrl']);

const onClick = () => {
  router.push({
    name: 'talent-pool-settings',
    params: { locationId: props.entityId },
  });
};
</script>

<style scoped>
.entity-card {
  border: 1px solid var(--palette-color-default-lighten-90);
  padding: 0.5rem;
  border-radius: 12px;
  flex: 1;
  min-width: 12rem;
  max-width: 20rem;
  transition: all 0.1s ease-out;

  &:hover {
    cursor: pointer;
    border-color: var(--palette-color-base-white);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    transition: all 0.1s ease-out;
  }
}
.content {
  padding: 0.5rem;
}
.name {
  font-size: 18px;
  font-weight: 600;
}
.locations {
  font-weight: 500;
}
.tags {
  color: var(--palette-color-default-lighten-20);
}
</style>
